import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { createReward } from '../../api/rewards';
import useSeries from '../../hooks/useSeries';

const CreateRewardPage = () => {
    const [loading, setLoading] = useState(false);
    const [rewardData, setRewardData] = useState({
        money: '',
        seriesID: '',
        numberOfSeries: '',
        cardID: '',
        seriesPct: '',
        cardPct: '',
        description: '',
    });

    const series = useSeries();

    const handleChange = e => {
        const { name, value } = e.target;
        setRewardData(prevData => ({ ...prevData, [name]: value }));
    };

    const handleSubmit = async e => {
        e.preventDefault();
        setLoading(true);
        try {
            await createReward(rewardData);
            toast.success('Reward created successfully!');
            setRewardData({
                money: '',
                seriesID: '',
                numberOfSeries: '',
                cardID: '',
                seriesPct: '',
                cardPct: '',
                description: '',
            });
        } catch (error) {
            toast.error('Error creating reward: ' + error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="admin-page create-reward-page">
            <h2>Create Reward</h2>
            <form className="admin-form admin-form--vertical" onSubmit={handleSubmit}>
                <div className="admin-field">
                    <label htmlFor="money">Money</label>
                    <input id="money" type="number" name="money" value={rewardData.money} onChange={handleChange} />
                </div>

                <div className="admin-form__row">
                    <div className="admin-field">
                        <label htmlFor="seriesID">Series</label>
                        <select id="seriesID" name="seriesID" value={rewardData.seriesID} onChange={handleChange}>
                            <option value="">Select a series</option>
                            {series.map(s => (
                                <option key={s.seriesID} value={s.seriesID}>
                                    {s.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="admin-field">
                        <label htmlFor="numberOfSeries">Number of Packs</label>
                        <input id="numberOfSeries" type="number" name="numberOfSeries" value={rewardData.numberOfSeries} onChange={handleChange} />
                    </div>
                </div>

                <div className="admin-field">
                    <label htmlFor="cardID">Card ID</label>
                    <input id="cardID" type="number" name="cardID" value={rewardData.cardID} onChange={handleChange} />
                </div>

                <div className="admin-form__row">
                    <div className="admin-field">
                        <label htmlFor="seriesPct">Series Percentage</label>
                        <input id="seriesPct" type="number" name="seriesPct" value={rewardData.seriesPct} onChange={handleChange} />
                    </div>
                    <div className="admin-field">
                        <label htmlFor="cardPct">Card Percentage</label>
                        <input id="cardPct" type="number" name="cardPct" value={rewardData.cardPct} onChange={handleChange} />
                    </div>
                </div>

                <div className="admin-field">
                    <label htmlFor="description">Description</label>
                    <textarea id="description" name="description" value={rewardData.description} onChange={handleChange} placeholder="Enter a description for the reward" />
                </div>

                <button type="submit" disabled={loading}>
                    {loading ? 'Creating...' : 'Create Reward'}
                </button>
            </form>
        </div>
    );
};

export default CreateRewardPage;
